import firebase, {
  initializeApp,
  firestore,
  auth,
  storage
} from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/analytics";
import "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

initializeApp(firebaseConfig);

export const getCollection = (name: string): firestore.CollectionReference =>
  firestore().collection(name);

const collections = {
  user: getCollection("user"),
  lead: getCollection("lead"),
  call: getCollection("call"),
  taskAttribute: getCollection("task_attribute"),
  dids: getCollection("dids"),
  scriptPromptPages: getCollection("script_prompt_pages"),
  productOptions: getCollection("product_options"),
  leaderBoard: getCollection("leaderboard"),
  upcomingCallbacks: getCollection("upcoming_callbacks"),
  twilioEvents: getCollection("twilio_events"),
  dispositions: getCollection("dispositions"),
  dispositionGroups: getCollection("dispositionGroups"),
  doctorNominations: getCollection("doctor_nominations"),
  messageTemplates: getCollection("message_templates"),
  logMessages: getCollection("log_messages"),
  customerServiceNotes: getCollection("customer_service_notes"),
  blacklistNumber: getCollection("blacklist_number")
};

export default firebase;

export { firestore, auth, collections, storage };
